import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ApiService } from '../../../Components/Services/apiServices';
import Skeleton from 'react-loading-skeleton';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import { Pagination, Autoplay } from 'swiper/modules';
import AuthModal from '../../../Components/Modals/AuthModals';

const HomeRooms = () => {

    const [rooms, setRooms] = useState([]);
    const [loading, setLoading] = useState(false);

    const [authmodals, setAuthModals] = useState(false);
    const [user, setUser] = useState(null);

    const handleClose = () => {
        setAuthModals(false);
    };

    useEffect(() => {
        const userData = localStorage.getItem("USER_DATA");
        if (userData) {
            setUser(JSON.parse(userData));
        }
    }, []);


    useEffect(() => {

        const fetchroom = async () => {
            try {
                setLoading(true);
                const roomData = await ApiService.Commanfetchrequest('rooms');
                setRooms(roomData);
                // console.log('room data:', roomData);
            } catch (error) {
                console.log('error while fetching:', error);
            } finally {
                setLoading(false);
            }
        }


        fetchroom();
    }, []);

    return (
        <>

            {loading ? (
                <>
                    <div className="container-xxl py-5">
                        <div className="container">
                            <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                                <h6 className="section-title text-center text-primary text-uppercase"><Skeleton width={100} height={20} /></h6>
                                <h1 className="mb-5"><Skeleton width={300} height={50} /></h1>
                            </div>
                            <div className="row g-4">
                                {Array.from({ length: 3 }).map((_, index) => (
                                    <div className="col-lg-4 col-md-6" key={index}>
                                        <div className="room-item shadow rounded overflow-hidden">
                                            <div className="position-relative">

                                                <Swiper
                                                    spaceBetween={50}
                                                    slidesPerView={1}
                                                    loop={true}
                                                    // autoplay={{ delay: 5000 }}
                                                    pagination={{ clickable: true }}
                                                    modules={[Pagination, Autoplay]}
                                                    navigation={true}
                                                >

                                                    <SwiperSlide>
                                                        <Skeleton width={"100%"} height={200} />
                                                        <small className="position-absolute start-0 bottom-0 translate-middle-y bg-gray text-white rounded py-1 px-3 ms-4">
                                                            <Skeleton width={100} height={40} />
                                                        </small>
                                                    </SwiperSlide>


                                                </Swiper>

                                            </div>

                                            <div className="p-4 mt-2">
                                                <div className="d-flex justify-content-between mb-3">
                                                    <h5 className="mb-0"><Skeleton width={200} height={40} /></h5>
                                                    <div className="ps-2">

                                                    </div>
                                                </div>
                                                <div className="d-flex mb-3">
                                                    <small className="border-end me-3 pe-3"><Skeleton width={20} height={15} /></small>
                                                    <small className="border-end me-3 pe-3"><Skeleton width={20} height={15} /></small>
                                                    <small><Skeleton width={20} height={15} /></small>
                                                </div>
                                                <p className="text-body mb-3"><Skeleton width={"100%"} height={100} /> </p>
                                                <div className="d-flex justify-content-between flex-md-row flex-column gap-2">
                                                    <a className="btn btn-sm  rounded py-2 px-4 w-100 w-md-auto" href="#"><Skeleton width={90} height={30} /></a>
                                                    <a className="btn btn-sm  rounded py-2 px-4 w-100 w-md-auto mt-2 mt-md-0" href="#"><Skeleton width={90} height={30} /></a>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                ))}


                            </div>
                        </div>
                    </div>
                    <div className='container text-center'>
                        <Link to="/rooms" className='btn text-center'><Skeleton width={180} height={40} /></Link>
                    </div>
                </>
            ) : (
                <>
                    <div className="container-xxl py-5">
                        <div className="container">
                            <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                                <h6 className="section-title text-center text-primary text-uppercase">Our Rooms</h6>
                                <h1 className="mb-5">Explore Our <span className="text-primary text-uppercase">Rooms</span></h1>
                            </div>
                            <div className="row g-4">
                                {rooms.map((room) => (
                                    <div className="col-lg-4 col-md-6" key={room.id}>
                                        <div className="room-item shadow rounded overflow-hidden">
                                            <div className="position-relative">

                                                <Swiper
                                                    spaceBetween={50}
                                                    slidesPerView={1}
                                                    loop={true}
                                                    // autoplay={{ delay: 5000 }}
                                                    pagination={{ clickable: true }}
                                                    modules={[Pagination, Autoplay]}
                                                    navigation={true}
                                                >
                                                    {room.room_images.map((image) => (
                                                        <SwiperSlide key={image.id}>
                                                            <img className="img-fluid" src={`https://hoteljpradmin.loopring.in/front/images/rooms/${image.room_images}`} alt={room.room_name} />
                                                            <small className="position-absolute start-0 bottom-0 translate-middle-y bg-primary text-white rounded py-1 px-3 ms-4">
                                                                ₹{room.room_price}/Day
                                                            </small>
                                                        </SwiperSlide>
                                                    ))}

                                                </Swiper>

                                            </div>

                                            <div className="p-4 mt-2">
                                                <div className="d-flex justify-content-between mb-3">
                                                    <h5 className="mb-0">{room.room_name}</h5>
                                                    <div className="ps-2">
                                                        <small className="fa fa-star text-primary" />
                                                        <small className="fa fa-star text-primary" />
                                                        <small className="fa fa-star text-primary" />
                                                        <small className="fa fa-star text-primary" />
                                                        <small className="fa fa-star text-primary" />
                                                    </div>
                                                </div>
                                                <div className="d-flex mb-3">
                                                    <small className="border-end me-3 pe-3"><i className="fa fa-bed text-primary me-2" />3 Bed</small>
                                                    <small className="border-end me-3 pe-3"><i className="fa fa-bath text-primary me-2" />2 Bath</small>
                                                    <small><i className="fa fa-wifi text-primary me-2" />Wifi</small>
                                                </div>
                                                <div className="mb-3">
                                                    {Number(room.room_quantity) === 0 ? (
                                                        <span className="badge bg-danger">Sold Out</span>
                                                    ) : (
                                                        <span className="badge bg-success">Available</span>
                                                    )}
                                                </div>
                                                <p className="text-body mb-3" dangerouslySetInnerHTML={{ __html: room.description }} />
                                                <div className="d-flex justify-content-between flex-md-row flex-column gap-2">
                                                    <Link to={`/room-detail/${room.room_name}`} className="btn btn-sm btn-primary rounded py-2 px-4 w-100 w-md-auto">View Detail</Link>
                                                    {Number(room.room_quantity) === 0  ? (
                                                        <button className="btn btn-sm btn-secondary rounded py-2 px-4 w-100 w-md-auto mt-2 mt-md-0" disabled>
                                                            Book Now
                                                        </button>
                                                    ) : (
                                                        <>
                                                            {user ? (
                                                                <Link to={`/room-detail/${room.room_name}`} className="btn btn-sm btn-dark rounded py-2 px-4 w-100 w-md-auto mt-2 mt-md-0">Book Now</Link>

                                                            ) : (
                                                                <Link to="#" onClick={() => setAuthModals(true)} className="btn btn-sm btn-dark rounded py-2 px-4 w-100 w-md-auto mt-2 mt-md-0">Book Now</Link>

                                                            )}
                                                        </>
                                                    )}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                ))}


                            </div>
                        </div>
                    </div>
                    <div className='container text-center'>
                        <Link to="/rooms" className='btn btn-primary text-center'>Explore More Rooms</Link>
                    </div>
                </>
            )}

            <AuthModal show={authmodals} handleClose={handleClose} />

        </>
    )
}

export default HomeRooms
